export default "__VITE_ASSET__BQtaaoF___"